export function yaCounterByHostname() {
	const counters = {
		'my.incognito.beta': 96625288,
		'mybeta.incognitocr.ru': 96625288,
		localhost: 96625288,
		'my2.incognitocr.ru': 58061740,
		'my.incognitocr.ru': 58061740,
	};
	return counters[window.location.hostname];
}
export default function yandexCounterClientId() {
	const counters = {
		'my.incognito.beta': window.yaCounter96625288,
		'mybeta.incognitocr.ru': window.yaCounter96625288,
		localhost: window.yaCounter96625288,
		'my2.incognitocr.ru': window.yaCounter58061740,
		'my.incognitocr.ru': window.yaCounter58061740,
	};

	const id = counters[window.location.hostname]?.getClientID();
	return id === undefined || id === 'undefined' ? null : id;
}
